import { ExaminerListType } from 'api';
import { ExaminerList } from './ExaminerList';

export const GeneralList = () => <ExaminerList listType={ExaminerListType.General} />;

export const CertificationExpiredList = () => (
  <ExaminerList listType={ExaminerListType.CertificationExpired} />
);

export const CertificationExpireSoonList = () => (
  <ExaminerList listType={ExaminerListType.CertificationExpireSoon} />
);

export const MonitoringExpiredList = () => (
  <ExaminerList listType={ExaminerListType.MonitoringExpired} />
);

export const MonitoringExpireSoonList = () => (
  <ExaminerList listType={ExaminerListType.MonitoringExpireSoon} />
);

export const TrainingNotCompletedList = () => (
  <ExaminerList listType={ExaminerListType.TrainingNotCompleted} />
);

export const TrainingUpcomingList = () => (
  <ExaminerList listType={ExaminerListType.TrainingUpcoming} />
);
